import React, {Suspense} from 'react';
import LoadingIndicator from '../core/components/LoadingIndicator';

// eslint-disable-next-line react/display-name,@typescript-eslint/explicit-module-boundary-types
export const Loadable = (Component: any) => (props: any) =>
  (
    <Suspense fallback={<LoadingIndicator label="Loading page"/>}>
      <Component {...props} />
    </Suspense>
  );
